<template>
  <div class="homePage">
    <div class="carousel">
      <el-carousel :height="carouselHeight" arrow="never">
        <el-carousel-item v-for="item in imagesBox" :key="item.id">
          <img :src="item.idView" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 优势介绍模块 -->
    <el-row type="flex" justify="center">
      <el-col :xs="24" :sm="24" :md="24" :lg="15" :xl="15">
        <div class="advantage">
          <div data-aos="fade-up" class="advantage_top">
            <h4>我们的优势</h4>
            <!-- <p>专业的团队成就技术指标和场景策略优势，识别准确率高于行业平均水平</p> -->
          </div>
          <div class="advantage_body">
            <div data-aos="flip-left" class="advantage_left hidden-sm-and-down">
              <el-image :src="require('@/assets/img/home/product_data.png')" lazy></el-image>
            </div>
            <div data-aos="fade-left" data-aos-duration="1000" class="advantage_right">
              <div class="advantage_item" v-for="(item,index) in advantageData" :key="index">
                <img :src="item.imgUrl" />
                <div class="item_right">
                  <h4>{{item.title}}</h4>
                  <p>{{item.text}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import "element-ui/lib/theme-chalk/display.css";

export default {
  name: "homePage",
  data() {
    return {
      clineHeight: document.body.clientWidth,
      carouselHeight: "850px",
      imagesBox: [
        { id: 0, idView: require("@/assets/img/home/banner1.png") },
        { id: 1, idView: require("@/assets/img/home/banner2.png") },
      ],
      advantageData: [
        {
          imgUrl: require("@/assets/img/home/home_icon1.png"),
          title: "实战场景",
          text:
            "不同的业务场景中，不断的训练、优化语音机器人。",
        },
        {
          imgUrl: require("@/assets/img/home/home_icon2.png"),
          title: "业务经验",
          text:
            "提供多领域的业务咨询、定制系统开发服务，优化运营效果。",
        },
        {
          imgUrl: require("@/assets/img/home/home_icon3.png"),
          title: "技术保障",
          text: "采用机器学习方式实现语义理解。",
        },
        {
          imgUrl: require("@/assets/img/home/home_icon4.png"),
          title: "产品支持",
          text: "全方位、多渠道功能保障，精准策略服务。",
        },
      ],
    };
  },
  created() {
    this.getCarouselHeightFunc();
  },
  mounted() {
    // window.onresize = this.getCarouselHeightFunc;
    window.addEventListener("resize", this.getCarouselHeightFunc);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getCarouselHeightFunc);
  },
  methods: {
    getCarouselHeightFunc: function () {
      this.carouselHeight = `${(document.body.clientWidth * 850) / 1920}px`;
    },
  },
};
</script>

<style lang="scss" scoped>
.homePage {
  background: rgba(247, 248, 252, 1);
  font-size: 0.9rem;
  font-weight: 300;
  border-top: 1px solid white;
  .carousel {
    // height: 850px;
    width: 100%;
    .el-carousel__container {
      // height: 850px;
      // overflow: hidden;
      // @media only screen and (max-width: 1200px){
      //   height:530px;
      // }
      margin: 0 auto;
      overflow: hidden;
      img {
        width: 100%;
      }
    }
  }
  .advantage {
    min-height: 38rem;
    padding: 1rem;
    text-align: center;
    // background: rgba(247, 248, 252, 1);
    .advantage_top {
      height: 4.6rem;
      // width: 60rem;
      line-height: 2em;
      margin: 5.9rem auto 0px;
      font-weight: 300;
      text-align: center;
      h4 {
        font-size: 1.8rem;
        margin-bottom: 1.8rem;
      }
      p {
        font-size: 0.9rem;
        line-height: 2em;
        margin: 0 2em;
      }
    }
    .advantage_body {
      // width: 60rem;
      display: flex;
      justify-content: space-between;
      margin: 0 auto 3rem;
      .advantage_left {
        margin-top: 136px;
      ::v-deep img {
          width: 25.6rem;
          height: 20.45rem;
        }
      }
      .advantage_right {
        margin: 5.7rem auto 0;
        width: 25rem;
        min-height: 21.1rem;
        display: flex;
        flex-wrap: wrap;
        .advantage_item {
          // height: 5.25rem;
          margin-bottom: 1.5rem;
          img {
            float: left;
            width: 1.5rem;
            margin-right: 1.5rem;
          }
          .item_right {
            flex: 1;
            width: 22rem;
            float: right;
            // line-height: 1.6em;
            text-align: left;
            h4 {
              font-size: 1.15rem;
              font-weight: 500;
              margin-bottom: 1rem;
            }
            p {
              font-size: 0.7rem;
              line-height: 2em;
              color: #333;
            }
          }
          @media only screen and (max-width: 996px) {
            font-size: 8px;
            .item_right>p {
              font-size: 0.5rem;
              line-height: 4em;
            }
          }
        }
      }
    }
  }
  .botton {
    width: 100%;
    background-color: #fff;
    border-top: 1px solid white;
    .botton_top {
      margin: 5.9rem auto 4rem;
      text-align: center;
      h4 {
        font-size: 1.8rem;
        font-weight: 300;
        margin-bottom: 1.85rem;
      }
      p {
        line-height: 2em;
        margin: 0 2em;
      }
    }
    .botton_body {
      display: flex;
      justify-content: center;
      margin-bottom: 2rem;
      ::v-deep .el-image {
        background-color: pink!important;
        width: 90%;
      }
    }
  }
}
</style>